import React from 'react';
import NewTabLink from '@sls-react/components/Links/NewTabLink';
import TradeInLanderCard from '@sls-react/components/TradeIn/TradeInLanderCard';
import { Button } from '@sls-react/components/Form/Button';
import { EVENT_DETAILS } from '../../pages/trade-in-events';
import DESKTOP_BG from '@sls-react/static/trade-in/desktop-bg.jpg';

interface Props {}

const TradeInDesktopLander: React.FC<Props> = () => {
  return (
    <div
      className="bg-center bg-cover bg-turf-green-500"
      style={{
        backgroundImage: `url(${DESKTOP_BG})`,
      }}
    >
      <div className="container pt-24 pb-16 mb-0">
        <h1 className="font-bold leading-tight text-center text-white uppercase text-8xl">
          Trade-in Events
        </h1>
        <h2 className="mb-10 text-5xl leading-tight text-center text-white uppercase">
          Powered by SidelineSwap
        </h2>

        <div className="px-8 py-6 bg-white rounded-lg shadow-lg text-true-black">
          <div className="mb-3 text-2xl font-bold text-center">
            UPCOMING EVENTS
          </div>

          <div className="mb-4 text-center">
            <NewTabLink
              className="text-xl font-semibold underline uppercase text-slate-green-500"
              href="https://sidelineswap.com/blog/p/311c275c-4404-4d6f-938b-bfffc8426b64/"
            >
              View Trade-in Guidelines
            </NewTabLink>
          </div>

          <div className="grid gap-4 md:col-span-2 lg:grid-cols-3">
            <div className="text-xl font-semibold">When</div>
            <div className="text-xl font-semibold lg:col-span-2">Where</div>

            <hr className="col-span-2 lg:col-span-3" />

            {EVENT_DETAILS.map((event, i) => (
              <React.Fragment key={i}>
                <div className="text-lg font-bold text-green-500">
                  {event.when}
                </div>

                <div className="text-lg font-semibold leading-tight text-slate-green-500 lg:col-span-2">
                  {event.where.join(' ')}
                </div>

                <hr className="col-span-2 lg:col-span-3" />
              </React.Fragment>
            ))}
          </div>
        </div>

        <div className="flex mt-8 grid gap-6 grid-cols-2">
          <TradeInLanderCard
            header="HOST"
            content="Want to plan a trade-in event to help your community cash in on their gear?"
            cta={
              <NewTabLink href="https://forms.gle/9djujT3fxhfmwaqr7">
                <Button>JOIN THE WAITING LIST</Button>
              </NewTabLink>
            }
          />

          <TradeInLanderCard
            header="WANT TO SELL MORE GEAR?"
            content="Trade-in events are easy to run and a great way for SidelineSwap sellers to grow their business."
            cta={
              <a href="mailto:partnerships@sidelineswap.com">
                <Button>CONTACT US</Button>
              </a>
            }
          />
        </div>
      </div>
    </div>
  );
};

export default TradeInDesktopLander;
